"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MainMenu = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _uuid = require("uuid");
var _MenuPropTypes = require("./MenuPropTypes");
var _SubMenuItems = require("./SubMenuItems");
require("./mainMenu.scss");
var _menuUtilityFunctions = require("./menuUtilityFunctions");
var _updateTree = require("./updateTree");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const MainMenu = _ref => {
  let {
    wrapper = {
      id: (0, _uuid.v4)(),
      customCssClass: ''
    },
    menuId,
    menuItems = [],
    behaviour = 'hamburger',
    layout = 'vertical',
    isHoverTrigger = false
  } = _ref;
  let activeMenuItem = null;
  const menuContainerRef = (0, _react.useRef)(null);
  const [menuItemsState, setMenuItemsState] = (0, _react.useState)(menuItems);
  const [activeMenuStateApplied, setActiveMenuStateApplied] = (0, _react.useState)(false);
  const handleActiveMenuFound = _ref2 => {
    let {
      treePosition
    } = _ref2;
    activeMenuItem = {
      treePosition
    };
  };
  const handleMenuButtonClick = (event, menuItem, treePosition) => {
    // Update tree state recursively
    const newState = (0, _updateTree.updateTree)(menuItemsState, treePosition);
    setMenuItemsState(newState);
  };
  (0, _react.useEffect)(() => {
    if (activeMenuItem && !activeMenuStateApplied) {
      const adjustedMenuState = [...menuItemsState];
      (0, _menuUtilityFunctions.AdjustItemInTree)({
        branch: adjustedMenuState,
        treePosition: activeMenuItem.treePosition,
        propertyToAdjust: 'isOpen',
        value: true,
        setAllParentValues: true
      });
      setActiveMenuStateApplied(true);
      setMenuItemsState(adjustedMenuState);
    }
  }, [activeMenuItem, activeMenuStateApplied, setMenuItemsState, menuItemsState]);

  // Handle hover and click outside of menu container
  (0, _react.useEffect)(() => {
    const menuContainerTarget = menuContainerRef.current;
    // Handler for hover menus (close on mouse leave)
    const handleMouseLeave = () => {
      setMenuItemsState(menuItemsState => menuItemsState.map(item => _objectSpread(_objectSpread({}, item), {}, {
        isOpen: false
      })));
    };

    // Handler for click menus (close on click outside)
    const handleClickOutside = event => {
      if (menuContainerRef.current && !menuContainerRef.current.contains(event.target)) {
        setMenuItemsState(menuItemsState => menuItemsState.map(item => _objectSpread(_objectSpread({}, item), {}, {
          isOpen: false
        })));
      }
    };
    if (isHoverTrigger && menuContainerTarget) {
      menuContainerTarget.addEventListener('mouseleave', handleMouseLeave);
    } else {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      if (isHoverTrigger && menuContainerTarget) {
        menuContainerTarget.removeEventListener('mouseleave', handleMouseLeave);
      } else {
        document.removeEventListener('mousedown', handleClickOutside);
      }
    };
  }, [isHoverTrigger]);
  return /*#__PURE__*/_react.default.createElement("nav", {
    id: wrapper.id,
    className: "mainMenuWrapper ".concat(behaviour, " ").concat(layout, " ").concat(wrapper.customCssClass),
    ref: menuContainerRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mainMenu ".concat(isHoverTrigger ? 'hoverBehaviours' : '')
  }, menuItemsState.length && /*#__PURE__*/_react.default.createElement(_SubMenuItems.SubMenuItems, {
    menuId: menuId,
    onActiveMenuFound: handleActiveMenuFound,
    onMenuButtonClick: handleMenuButtonClick,
    subMenuItems: menuItemsState,
    subMenuId: "".concat(menuId, "_subMenu_1"),
    level: 1,
    isHoverTrigger: isHoverTrigger
  })));
};
exports.MainMenu = MainMenu;
MainMenu.propTypes = {
  wrapper: _propTypes.default.shape({
    customCssClass: _propTypes.default.string,
    id: _propTypes.default.string
  }),
  menuId: _propTypes.default.string.isRequired,
  layout: _propTypes.default.oneOf(['horizontal', 'vertical']),
  behaviour: _propTypes.default.oneOf(['hamburger']),
  menuItems: _propTypes.default.arrayOf(_MenuPropTypes.MenuItemPropTypes),
  isHoverTrigger: _propTypes.default.bool
};
var _default = exports.default = MainMenu;